
// src/components/PopupService.js
const PopupService = (function() {
    let instance;
    let popupElement = null;
    let confirmElement = null;

    // Helper to break lines at spaces, not splitting words


	function breakLines(str, maxLen = 150) {
	    let lines = [];
	    let i = 0;
	    while (i < str.length) {
	        let end = i + maxLen;
	        if (end >= str.length) {
	            lines.push(str.slice(i));
	            break;
	        }
	        // If splitting in the middle of a word, add a hyphen
	        if (/\w/.test(str[end - 1]) && /\w/.test(str[end])) {
	            lines.push(str.slice(i, end - 1) + '-');
	            i = end - 1;
	        } else {
	            lines.push(str.slice(i, end));
	            i = end;
	        }
	    }
	    return lines.join('<br>');
	}



    function createInstance() {
        return {
            showMessage: function (message, isSuccess, duration = 2000) {
                if (!popupElement) {
                    popupElement = document.getElementById('globalPopupMessage');
                    if (!popupElement) {
                        popupElement = document.createElement('div');
                        popupElement.id = 'tempGlobalPopupMessage';
                        popupElement.style.position = 'fixed';
                        popupElement.style.bottom = '20px';
                        popupElement.style.right = '20px';
                        popupElement.style.padding = '15px';
                        popupElement.style.borderRadius = '4px';
                        popupElement.style.zIndex = '9999';
                        popupElement.style.width = '300px';
                        popupElement.style.maxWidth = '80vw';
                        popupElement.style.boxSizing = 'border-box';
                        popupElement.style.wordWrap = 'break-word';
                        document.body.appendChild(popupElement);
                    }
                }
                const formattedMessage = breakLines(message, 150);
                popupElement.style.transition = 'opacity 0.3s ease';
                popupElement.style.opacity = '1';
                popupElement.innerHTML = formattedMessage;
                popupElement.style.backgroundColor = isSuccess ? '#d4edda' : '#f8d7da';
                popupElement.style.color = isSuccess ? '#155724' : '#721c24';
                popupElement.style.display = 'block';
                const currentElement = popupElement;
                setTimeout(() => {
                    if (currentElement && document.body.contains(currentElement)) {
                        currentElement.style.opacity = '0';
                        setTimeout(() => {
                            if (currentElement && document.body.contains(currentElement)) {
                                currentElement.style.display = 'none';
                                if (currentElement.id === 'tempGlobalPopupMessage') {
                                    document.body.removeChild(currentElement);
                                    if (currentElement === popupElement) {
                                        popupElement = null;
                                    }
                                }
                            }
                        }, 400);
                    }
                }, duration);
            },
            showConfirm: function(message) {
                if (confirmElement) {
                    document.body.removeChild(confirmElement);
                    confirmElement = null;
                }
                return new Promise((resolve) => {
                    confirmElement = document.createElement('div');
                    confirmElement.style.position = 'fixed';
                    confirmElement.style.top = '0';
                    confirmElement.style.left = '0';
                    confirmElement.style.width = '100vw';
                    confirmElement.style.height = '100vh';
                    confirmElement.style.background = 'rgba(0,0,0,0.3)';
                    confirmElement.style.display = 'flex';
                    confirmElement.style.alignItems = 'center';
                    confirmElement.style.justifyContent = 'center';
                    confirmElement.style.zIndex = '10000';

                    const dialog = document.createElement('div');
                    dialog.style.background = '#fff';
                    dialog.style.padding = '24px 20px 16px 20px';
                    dialog.style.borderRadius = '6px';
                    dialog.style.boxShadow = '0 2px 12px rgba(0,0,0,0.2)';
                    dialog.style.maxWidth = '400px';
                    dialog.style.width = '90vw';
                    dialog.style.textAlign = 'center';

                    const msg = document.createElement('div');
                    msg.style.marginBottom = '18px';
                    msg.style.wordBreak = 'break-word';
                    msg.innerHTML = breakLines(message, 50);

                    const btnOk = document.createElement('button');
                    btnOk.textContent = 'OK';
                    btnOk.style.margin = '0 10px';
                    btnOk.style.padding = '6px 18px';
                    btnOk.style.background = '#2c991c';
                    btnOk.style.color = '#fff';
                    btnOk.style.border = 'none';
                    btnOk.style.borderRadius = '3px';
                    btnOk.style.cursor = 'pointer';

                    const btnCancel = document.createElement('button');
                    btnCancel.textContent = 'Cancel';
                    btnCancel.style.margin = '0 10px';
                    btnCancel.style.padding = '6px 18px';
                    btnCancel.style.background = '#6c757d';
                    btnCancel.style.color = '#fff';
                    btnCancel.style.border = 'none';
                    btnCancel.style.borderRadius = '3px';
                    btnCancel.style.cursor = 'pointer';

                    btnOk.onclick = () => {
                        document.body.removeChild(confirmElement);
                        confirmElement = null;
                        resolve(true);
                    };
                    btnCancel.onclick = () => {
                        document.body.removeChild(confirmElement);
                        confirmElement = null;
                        resolve(false);
                    };

                    dialog.appendChild(msg);
                    dialog.appendChild(btnOk);
                    dialog.appendChild(btnCancel);
                    confirmElement.appendChild(dialog);
                    document.body.appendChild(confirmElement);
                });
            }
        };
    }

    return {
        getInstance: function() {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();

export default PopupService;
